module.exports = __webpack_public_path__ + "img/floating-icon.0a38a7da.svg";